import { IdKey } from '@alltrails/shared/types/lists';
import IconButton from '@alltrails/shared/denali/components/IconButton';
import Remove from '@alltrails/shared/icons/Remove';
import Handle from '@alltrails/shared/icons/Handle';
import ListRowImage from '@alltrails/shared/components/ListRowImage';
import { deleteList } from 'api/List';
import logError from 'utils/logError';
import List from 'types/List';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import { LanguageSupportUtil } from '../../utils/language_support_util';

import * as styles from '../ListContainer/styles/styles.module.scss';
import { XLATE_NONE } from '../../Constants';

type Props = {
  lists: List[];
  list: List;
  idx: number;
  allowEditing: boolean;
  setLists: (lists: List[]) => void;
  dragHandleProps?: any;
};

const ListRow = ({ lists, list, idx, allowEditing, setLists, dragHandleProps = null }: Props): JSX.Element => {
  const languageRegionCode = useLanguageRegionCode();
  const handleDeleteListClick = async (listId: IdKey) => {
    if (confirm('Are you sure you want to delete this list?')) {
      try {
        const result = await deleteList(listId);
        if (result && result.lists) {
          // remove deleted list immediately
          const removedId = result.lists[0].id;
          const newItems = lists.filter(l => l.id !== removedId);
          setLists(newItems);
        }
      } catch {
        logError('Error when deleting the list');
      }
    }
  };

  const userUrl = LanguageSupportUtil.wrapUrlSafe(`/members/${list.user.slug}`, languageRegionCode);
  const listUrl = LanguageSupportUtil.wrapUrlSafe(`/explore/list/${list?.slug}`, languageRegionCode);

  return (
    <li className={styles.container} data-id={idx} key={idx}>
      <ListRowImage listId={list.id} emptyList={list.metadata?.itemsCount === 0} />
      <div className={styles.titleAndContents}>
        <a href={listUrl} className={`link ${XLATE_NONE}`}>
          <div className={styles.listTitle}>{list.name}</div>
        </a>
        <a href={userUrl} className={`link ${XLATE_NONE}`}>
          <div className={styles.listLink}>{`${list.user.firstName} ${list.user.lastName}`}</div>
        </a>
      </div>
      {allowEditing && (
        <div className={styles.controlsContainer}>
          <div {...dragHandleProps} title="Move List" className={styles.dragHandle}>
            <Handle size="md" />
          </div>
          <IconButton
            icon={{ Component: Remove }}
            onClick={() => handleDeleteListClick(list.id)}
            size="md"
            className={styles.removeIcon}
            testId="deleteFromList"
            title="Delete from list"
            variant="flat"
          />
        </div>
      )}
    </li>
  );
};

export default ListRow;
